import type { ReactNode } from 'react';

import * as SC from './LayoutStyles';

import { Header } from '@/components/Header/Header';

type LayoutProps = {
  children: ReactNode;
  showCancelVerification?: boolean;
};

export const Layout = ({ children, showCancelVerification }: LayoutProps) => {
  return (
    <>
      <Header showCancelVerification={showCancelVerification} />
      <SC.Main>{children}</SC.Main>
    </>
  );
};
